var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SInput',{attrs:{"placeholder":_vm.placeholder,"label":_vm.label,"hint":_vm.hint,"error":_vm.error,"disabled":_vm.disabled,"readonly":true,"border":_vm.border,"icon":'calendar',"type":"datePicker","value":_vm.value,"dateFormat":_vm.dateFormat,"clearButtonIcon":false},on:{"input":_vm.input,"clear":_vm.clear}})
}
var staticRenderFns = []

export { render, staticRenderFns }